var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('landing-banner'),_c('landing-course-preview'),(
      _vm.LiveCourses &&
        _vm.LiveCourses.todayLiveCourses &&
        _vm.LiveCourses.todayLiveCourses.length > 0
    )?_c('landing-live',{attrs:{"liveCourses":_vm.LiveCourses.todayLiveCourses}}):_vm._e(),_c('landing-teachers',{attrs:{"teacherArray":_vm.teacherArray}}),_c('Testimonials',{attrs:{"reviews":_vm.CourseReviews}}),_c('call-to-action')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }